import { NgModule } from '@angular/core'

import { AuthService } from './auth'
import { AreaService } from './area/base'
import { LectureService } from './lecture'
import { UserService } from './user'
import { PlayHistoryService } from './play-history/base'
import { PlayCountService } from './play-count/base'
import { EventService } from './event/base'
import { YoutubePlayerService } from './youtube-player'
import { VideoService } from './video'
import { SharingGroupService } from './sharing-group'
import { YouTubeCaptionService } from './youtube-caption'
import { GoogleSignInService } from './google-sign-in'
import { MicrosoftSignInService } from './microsoft-sign-in'
import { StaticContentService } from './static-content'
import { DirectUploadService } from './direct-upload'
import { VideoAreaService } from './area/video'
import { StaticContentAreaService } from './area/static-content'
import { StaticContentPlayHistoryService } from './play-history/static-content'
import { VideoPlayHistoryService } from './play-history/video'
import { VideoEventService } from './event/video'
import { StaticContentEventService } from './event/static-content'
import { StaticContentPlayCountService } from './play-count/static-content'
import { VideoPlayCountService } from './play-count/video'
import { SerialService } from './serial-log'

@NgModule({
  providers: [
    AuthService,
    VideoAreaService,
    StaticContentAreaService,
    LectureService,
    UserService,
    StaticContentPlayHistoryService,
    VideoPlayHistoryService,
    VideoPlayCountService,
    StaticContentPlayCountService,
    StaticContentEventService,
    VideoEventService,
    YoutubePlayerService,
    VideoService,
    SharingGroupService,
    YouTubeCaptionService,
    GoogleSignInService,
    MicrosoftSignInService,
    StaticContentService,
    DirectUploadService,
    SerialService,
  ],
})
export class ServicesModule { }

export {
  AuthService,
  AreaService,
  LectureService,
  UserService,
  PlayHistoryService,
  PlayCountService,
  EventService,
  YoutubePlayerService,
  VideoService,
  SharingGroupService,
  YouTubeCaptionService,
  GoogleSignInService,
  MicrosoftSignInService,
  StaticContentService,
  DirectUploadService,
  VideoAreaService,
  VideoPlayHistoryService,
  VideoEventService,
  StaticContentAreaService,
  StaticContentPlayHistoryService,
  StaticContentEventService,
  VideoPlayCountService,
  StaticContentPlayCountService,
  SerialService,
}



// WEBPACK FOOTER //
// ./src/services/index.ts